import { render, staticRenderFns } from "./detailPageGangchan.vue?vue&type=template&id=1b26c880&scoped=true"
import script from "./detailPageGangchan.vue?vue&type=script&lang=js"
export * from "./detailPageGangchan.vue?vue&type=script&lang=js"
import style0 from "./detailPageGangchan.vue?vue&type=style&index=0&id=1b26c880&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b26c880",
  null
  
)

export default component.exports